(function () {
  function getAnchorTarget(link) {
    if (!link || !link.getAttribute) {
      return null;
    }

    var href = link.getAttribute('href');
    if (!href) {
      return null;
    }

    if (href.charAt(0) === '#') {
      return href.slice(1);
    }

    try {
      var url = new URL(href, window.location.origin);
      if (url.pathname !== window.location.pathname || url.hostname !== window.location.hostname) {
        return null;
      }

      if (url.hash) {
        return url.hash.replace('#', '');
      }
    } catch (e) {
      return null;
    }

    return null;
  }

  function scrollToTarget(targetId) {
    var target = document.getElementById(targetId);
    if (!target) {
      return;
    }

    var offset = 200;
    var targetTop = target.getBoundingClientRect().top + window.scrollY - offset;

    window.scrollTo({
      top: Math.max(targetTop, 0),
      behavior: 'smooth'
    });
  }

  function handleMenuClick(event) {
    var link = event.target.closest('.menu--primary a');
    if (!link) {
      return;
    }

    var targetId = getAnchorTarget(link);
    if (!targetId) {
      return;
    }

    event.preventDefault();
    scrollToTarget(targetId);

    if (history.pushState) {
      history.pushState(null, '', '#' + targetId);
    } else {
      window.location.hash = targetId;
    }
  }

  document.addEventListener('click', handleMenuClick);

  function setupMobileNav() {
    var nav = document.querySelector('[data-mobile-nav]');
    if (!nav) {
      return;
    }

    var toggle = nav.querySelector('.main-nav__toggle');
    var content = nav.querySelector('#main-nav-content');
    if (!toggle || !content) {
      return;
    }

    function closeNav() {
      nav.classList.remove('main-nav--open');
      toggle.setAttribute('aria-expanded', 'false');
    }

    toggle.addEventListener('click', function () {
      var isOpen = nav.classList.toggle('main-nav--open');
      toggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
    });

    content.addEventListener('click', function (event) {
      var link = event.target.closest('a');
      if (link) {
        closeNav();
      }
    });
  }

  function setupContactForm() {
    var form = document.querySelector('.contact-us__form');
    if (!form) {
      return;
    }

    var checkbox = form.querySelector('.contact-us__checkbox');
    var submit = form.querySelector('.contact-us__submit');
    if (!checkbox || !submit) {
      return;
    }

    function updateSubmitState() {
      submit.disabled = !checkbox.checked;
    }

    checkbox.addEventListener('change', updateSubmitState);
    updateSubmitState();
  }

  function setupFaqsToggle() {
    var items = Array.prototype.slice.call(document.querySelectorAll('.faqs__item'));
    if (!items.length) {
      return;
    }

    items.forEach(function (item) {
      item.addEventListener('click', function (event) {
        if (event.target.closest('summary')) {
          return;
        }

        var isOpen = item.hasAttribute('open');
        if (isOpen) {
          item.removeAttribute('open');
        } else {
          item.setAttribute('open', '');
        }
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setupContactForm);
    document.addEventListener('DOMContentLoaded', setupMobileNav);
    document.addEventListener('DOMContentLoaded', setupFaqsToggle);
  } else {
    setupContactForm();
    setupMobileNav();
    setupFaqsToggle();
  }

  function setupJobsFilters() {
    var listing = document.querySelector('.jobs-listing');
    if (!listing) {
      return;
    }

    var searchInput = listing.querySelector('.jobs-search__input');
    var results = listing.querySelector('.jobs-search__results');
    var cards = Array.prototype.slice.call(listing.querySelectorAll('.jobs-card'));
    var checkboxes = Array.prototype.slice.call(listing.querySelectorAll('.jobs-filter__checkbox'));
    var slugFilterMode = listing.getAttribute('data-filter-mode') === 'slug';
    var jobsBase = listing.getAttribute('data-jobs-base') || window.location.pathname;
    var dateRadios = Array.prototype.slice.call(listing.querySelectorAll('input[name="jobs-date-filter"]'));
    var emptyState = listing.querySelector('.jobs-empty');

    if (!searchInput || !results) {
      return;
    }

    function getSelectedTypes() {
      if (slugFilterMode) {
        return [];
      }
      return checkboxes
        .filter(function (checkbox) { return checkbox.checked; })
        .map(function (checkbox) { return checkbox.value; });
    }

    function getSelectedDateDays() {
      if (!dateRadios.length) {
        return null;
      }
      var selected = dateRadios.find(function (radio) { return radio.checked; });
      if (!selected) {
        return null;
      }
      if (selected.value === 'all') {
        return null;
      }
      var days = parseInt(selected.value, 10);
      return isNaN(days) ? null : days;
    }

    function updateUrl(searchTerm, selectedTypes) {
      var params = new URLSearchParams(window.location.search);
      if (searchTerm) {
        params.set('search', searchTerm);
      } else {
        params.delete('search');
      }
      if (selectedTypes.length) {
        params.set('filters', selectedTypes.join(','));
      } else {
        params.delete('filters');
      }

      var newQuery = params.toString();
      var newUrl = window.location.pathname + (newQuery ? '?' + newQuery : '');
      if (history.replaceState) {
        history.replaceState(null, '', newUrl);
      }
    }

    function updateResults(searchTerm, count) {
      if (searchTerm) {
        results.textContent = 'Showing ' + count + ' results for "' + searchTerm + '"';
      } else {
        results.textContent = 'Showing ' + count + ' jobs';
      }
    }

    function applyFilters() {
      var searchTerm = searchInput.value.trim().toLowerCase();
      var selectedTypes = getSelectedTypes();
      var selectedDays = getSelectedDateDays();
      var visibleCount = 0;

      cards.forEach(function (card) {
        var typesAttr = card.getAttribute('data-types') || card.getAttribute('data-type') || '';
        var typeList = typesAttr
          .split(',')
          .map(function (value) { return value.trim().toLowerCase(); })
          .filter(Boolean);
        var title = card.getAttribute('data-title') || '';
        var description = card.getAttribute('data-description') || '';
        var tags = card.getAttribute('data-tags') || '';
        var matchesType = !selectedTypes.length || selectedTypes.some(function (value) {
          return typeList.indexOf(value.toLowerCase()) !== -1;
        });
        var matchesSearch = !searchTerm || title.indexOf(searchTerm) !== -1 || description.indexOf(searchTerm) !== -1 || tags.indexOf(searchTerm) !== -1;
        var matchesDate = true;
        if (selectedDays) {
          var created = card.getAttribute('data-created') || '';
          var createdTime = Date.parse(created);
          if (!isNaN(createdTime)) {
            var daysPassed = (Date.now() - createdTime) / 86400000;
            matchesDate = daysPassed < selectedDays;
          } else {
            matchesDate = false;
          }
        }
        var show = matchesType && matchesSearch && matchesDate;
        card.style.display = show ? '' : 'none';
        if (show) {
          visibleCount += 1;
        }
      });

      if (emptyState) {
        emptyState.style.display = visibleCount === 0 ? 'block' : 'none';
      }

      updateResults(searchTerm, visibleCount);
      if (!slugFilterMode) {
        updateUrl(searchTerm, selectedTypes);
      }
    }

    function buildFilterUrl(base, aircraftSlug, roleSlug) {
      var cleanBase = base.replace(/\/+$/, '');
      var parts = [];
      if (aircraftSlug) {
        parts.push(aircraftSlug);
      }
      if (roleSlug) {
        parts.push(roleSlug);
      }
      if (!parts.length) {
        return cleanBase + '/';
      }
      return cleanBase + '/' + parts.join('/') + '/';
    }

    function handleSlugFiltersChange(event) {
      var checkbox = event.target.closest('.jobs-filter__checkbox');
      if (!checkbox) {
        return;
      }

      var group = checkbox.getAttribute('data-filter-group') || '';
      if (checkbox.checked && group) {
        checkboxes.forEach(function (item) {
          if (item !== checkbox && item.getAttribute('data-filter-group') === group) {
            item.checked = false;
          }
        });
      }

      var aircraftSlug = '';
      var roleSlug = '';
      checkboxes.forEach(function (item) {
        if (!item.checked) {
          return;
        }
        var itemGroup = item.getAttribute('data-filter-group');
        var slug = item.getAttribute('data-filter-slug') || item.value || '';
        if (itemGroup === 'aircraft') {
          aircraftSlug = slug;
        } else if (itemGroup === 'role') {
          roleSlug = slug;
        }
      });

      window.location.href = buildFilterUrl(jobsBase, aircraftSlug, roleSlug);
    }

    var params = new URLSearchParams(window.location.search);
    var initialSearch = params.get('search') || '';
    var initialFilters = params.get('filters');
    var initialTypes = initialFilters ? initialFilters.split(',') : [];

    searchInput.value = initialSearch;
    if (!slugFilterMode && initialTypes.length) {
      checkboxes.forEach(function (checkbox) {
        checkbox.checked = initialTypes.indexOf(checkbox.value) !== -1;
      });
    }

    searchInput.addEventListener('input', applyFilters);
    if (slugFilterMode) {
      checkboxes.forEach(function (checkbox) {
        checkbox.addEventListener('change', handleSlugFiltersChange);
      });
    } else {
      checkboxes.forEach(function (checkbox) {
        checkbox.addEventListener('change', applyFilters);
      });
    }
    dateRadios.forEach(function (radio) {
      radio.addEventListener('change', applyFilters);
    });

    applyFilters();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setupJobsFilters);
  } else {
    setupJobsFilters();
  }

  function setupApplySticky() {
    var actions = document.querySelector('.jobs-detail-actions');
    if (!actions) {
      return;
    }

    var placeholder = document.createElement('div');
    placeholder.className = 'jobs-detail-actions-placeholder';
    actions.parentNode.insertBefore(placeholder, actions);

    var header = document.querySelector('.main-nav');
    var fixedClass = 'is-fixed';
    var actionsHeight = 0;
    var applyTop = 0;
    var actionsWidth = 0;
    var lastWidth = window.innerWidth;

    function getFixedTop() {
      var headerHeight = header ? header.getBoundingClientRect().height : 0;
      var rootSize = parseFloat(window.getComputedStyle(document.documentElement).fontSize) || 16;
      return headerHeight + (1.5 * rootSize) - 10;
    }

    function getSnapOffset() {
      var rootSize = parseFloat(window.getComputedStyle(document.documentElement).fontSize) || 16;
      return (1.5 * rootSize) - 10;
    }

    function getHeaderHeight() {
      return header ? header.getBoundingClientRect().height : 0;
    }

    function updateMeasurements() {
      actionsHeight = actions.offsetHeight;
      var rect = actions.getBoundingClientRect();
      applyTop = rect.top + window.scrollY;
      var styles = window.getComputedStyle(actions);
      var padLeft = parseFloat(styles.paddingLeft) || 0;
      var padRight = parseFloat(styles.paddingRight) || 0;
      actionsWidth = rect.width - padLeft - padRight;
    }

    function onScroll() {
      if (window.innerWidth > 900) {
        actions.classList.remove(fixedClass);
        actions.style.top = '';
        actions.style.width = '';
        placeholder.style.height = '';
        return;
      }

      var fixedTop = getFixedTop();
      var snapOffset = getSnapOffset();
      var headerHeight = getHeaderHeight();
      var shouldFix = window.scrollY >= (applyTop - snapOffset - headerHeight);

      if (shouldFix) {
        actions.classList.add(fixedClass);
        actions.style.top = fixedTop + 'px';
        actions.style.width = actionsWidth + 'px';
        placeholder.style.height = actionsHeight + 'px';
      } else {
        actions.classList.remove(fixedClass);
        actions.style.top = '';
        actions.style.width = '';
        placeholder.style.height = '';
      }
    }

    updateMeasurements();
    onScroll();

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', function () {
      if (window.innerWidth !== lastWidth) {
        lastWidth = window.innerWidth;
        updateMeasurements();
      }
      onScroll();
    });
    window.addEventListener('load', function () {
      updateMeasurements();
      onScroll();
    });
  }

  function setupScrollProgress() {
    var progressRoot = document.querySelector('[data-scroll-progress]');
    if (!progressRoot) {
      return;
    }

    var bar = progressRoot.querySelector('[data-scroll-progress-bar]');
    var plane = progressRoot.querySelector('[data-scroll-progress-plane]');
    if (!bar || !plane) {
      return;
    }

    var ticking = false;

    function clamp(value) {
      return Math.min(100, Math.max(0, value));
    }

    function update() {
      var doc = document.documentElement;
      var scrollTop = window.scrollY || doc.scrollTop || 0;
      var scrollHeight = doc.scrollHeight - window.innerHeight;
      var next = scrollHeight > 0 ? (scrollTop / scrollHeight) * 100 : 0;
      var progress = clamp(next);
      bar.style.width = progress + '%';
      plane.style.left = progress + '%';
      ticking = false;
    }

    function onScroll() {
      if (!ticking) {
        ticking = true;
        window.requestAnimationFrame(update);
      }
    }

    update();
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setupScrollProgress);
  } else {
    setupScrollProgress();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setupApplySticky);
  } else {
    setupApplySticky();
  }
})();

